import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";

function App() {
  useEffect(() => {
    // Google Ads Global Site Tag
    const script1 = document.createElement('script');
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17979371888';
    script1.async = true;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17979371888');
      
      // Conversion tracking function
      window.gtag_report_conversion = function(url) {
        var callback = function () {
          if (typeof(url) != 'undefined') {
            window.open(url, '_blank');
          }
        };
        gtag('event', 'conversion', {
          'send_to': 'AW-17979371888/tKC2CMmQs5IcEPDinf1C',
          'event_callback': callback
        });
        return false;
      }
    `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

